import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const name = "PostalMail";
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({
    name,
    initialState,
    extraReducers: (builder) => {
        createExtraReducers(builder, extraActions);
    },
});

// exports

export const PostalMailActions = { ...slice.actions, ...extraActions };
export const PostalMailReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        LoadKioskMailDocumentSearchDetails: [],
        loadUpdatePostalMailReadStatusResponse: []
    };
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}`;


    return {
        getLoadKioskMailDocumentSearch: getLoadKioskMailDocumentSearch(),
        loadUpdatePostalMailReadStatus: loadUpdatePostalMailReadStatus()
    };


    function getLoadKioskMailDocumentSearch() {
        return createAsyncThunk(
            `${name}/getLoadKioskMailDocumentSearch`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/KioskPostMail/LoadKioskMailDocumentSearch`, objData)
        );
    }

    function loadUpdatePostalMailReadStatus() {
        return createAsyncThunk(
            `${name}/loadUpdatePostalMailReadStatus`,
            async (mailScanningDocumentID) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/KioskPostMail/UpdatePostalMailReadStatus?mailScanningDocumentID=${mailScanningDocumentID}`)
        );
    }

}

function createExtraReducers(builder, actions) {
    builder
        .addCase(actions.getLoadKioskMailDocumentSearch.pending, (state) => {
            //state.LoadKioskMailDocumentSearchDetails = [];
        })
        .addCase(actions.getLoadKioskMailDocumentSearch.fulfilled, (state, action) => {
            state.LoadKioskMailDocumentSearchDetails = action.payload;
        })
        .addCase(actions.getLoadKioskMailDocumentSearch.rejected, (state, action) => {
            state.LoadKioskMailDocumentSearchDetails = { error: action.error };
        })
        .addCase(actions.loadUpdatePostalMailReadStatus.pending, (state) => {
            state.loadUpdatePostalMailReadStatusResponse = [];
        })
        .addCase(actions.loadUpdatePostalMailReadStatus.fulfilled, (state, action) => {
            state.loadUpdatePostalMailReadStatusResponse = action.payload;
        })
        .addCase(actions.loadUpdatePostalMailReadStatus.rejected, (state, action) => {
            state.loadUpdatePostalMailReadStatusResponse = { error: action.error };
        });
}
